import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getTabsContentStart,
  getTabsContentSuccess,
  getTabsContentFailed,
} from "../redux/getTabsContent";

import { getReseachReportTabsApi } from "core/http/service/researchReport";

function* getTabsContent() {
  try {
    const res = yield call(getReseachReportTabsApi);

    yield put({
      type: getTabsContentSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getTabsContentFailed.type,
    });
  }
}

function* watchGetTabsContent() {
  yield takeLatest(getTabsContentStart.type, getTabsContent);
}

export default function* getTabsContentSaga() {
  yield all([watchGetTabsContent()]);
}
